import { choose } from '../../utils/platform';
import UserFormDesktop from './UserForm.desktop';
import UserFormMobile from './UserForm.mobile';

// Platform chooser: the APK renders the mobile variant, any browser the desktop one.
// Both take the same props; all logic lives in the owning page's hook.
export default choose(UserFormDesktop, UserFormMobile);
